/** 1 lakh rupees = ₹100,000 = 10,000,000 paise. */
export const CTC_LAKHS_TO_PAISE = 10_000_000;
export const CTC_MAX_LAKHS = 100;
export const CTC_MAX_PAISE = CTC_MAX_LAKHS * CTC_LAKHS_TO_PAISE;

export const CTC_RUPEE_SCALE_ERROR =
  "Enter lakhs, not rupees. For ₹9 LPA type 9, not 90000.";
export const CTC_MAX_LPA_ERROR = "Maximum is 100 LPA. Enter annual CTC in lakhs (e.g. 8.5).";

export function lakhsToPaise(lakhs: number): number {
  return Math.round(Number(lakhs) * CTC_LAKHS_TO_PAISE);
}

/** Convert an optional CTC field to paise without turning a cleared value into zero. */
export function optionalLakhsToPaise(value: unknown): number | undefined {
  return value == null || value === "" ? undefined : lakhsToPaise(Number(value));
}

export function paiseToLakhs(paise: number): number {
  return paise / CTC_LAKHS_TO_PAISE;
}

/** Live typing: empty is ok; over 100 / rupee-scale is rejected immediately. */
export function ctcLakhsLiveError(value: unknown): string | null {
  if (value == null || value === "") return null;
  const n = Number(value);
  if (!Number.isFinite(n) || n < 0) return "Enter a valid amount in lakhs";
  if (n >= 1000) return CTC_RUPEE_SCALE_ERROR;
  if (n > CTC_MAX_LAKHS) return CTC_MAX_LPA_ERROR;
  return null;
}

/** Validate annual CTC entered in lakhs (not rupees). */
export function validateCtcLakhs(value: unknown): string | null {
  if (value == null || value === "") return "Enter CTC in lakhs per year";
  return ctcLakhsLiveError(value);
}
